"use strict";
/* eslint-disable import/prefer-default-export */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockChallengeTeamsLeaderboard = exports.mockChallengeUsersLeaderboard = exports.mockChallenges = void 0;
exports.mockChallenges = {
    challenges: [
        {
            uuid: '6167f2408df887dad076a616',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f2408df887dad076a616',
            displayName: 'Fundamental Challenge for Android',
            language: 'Android',
            level: 'Basic',
            maxScore: 10000,
            taken: true,
            highestScore: 7514,
        },
        {
            uuid: '6167f23bc27d3d92df9529f5',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23bc27d3d92df9529f5',
            displayName: 'Fundamental Challenge for .Net',
            language: '.Net',
            level: 'Basic',
            maxScore: 10000,
            taken: false,
        },
        {
            uuid: '6167f23f8df88728e476a610',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23f8df88728e476a610',
            displayName: 'Fundamental Challenge for C/C++',
            language: 'C/C++',
            level: 'Basic',
            maxScore: 10000,
            taken: false,
        },
        {
            uuid: '6167f2408df8872a0e76a613',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f2408df8872a0e76a613',
            displayName: 'Fundamental Challenge for Go',
            language: 'Go',
            level: 'Basic',
            maxScore: 10000,
            taken: false,
        },
        {
            uuid: '6167f23ec27d3d4f8d952a01',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23ec27d3d4f8d952a01',
            displayName: 'Fundamental Challenge for iOS',
            language: 'iOS',
            level: 'Basic',
            maxScore: 10000,
            taken: false,
        },
        {
            uuid: '6167f23f2479f1d557d557e3',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23f2479f1d557d557e3',
            displayName: 'Fundamental Challenge for NodeJs',
            language: 'NodeJs',
            level: 'Basic',
            maxScore: 10000,
            taken: true,
            highestScore: 8562,
        },
        {
            uuid: '6167f23c8df887633876a607',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23c8df887633876a607',
            displayName: 'Fundamental Challenge for Scala',
            language: 'Scala',
            level: 'Basic',
            maxScore: 10000,
            taken: true,
            highestScore: 8956,
        },
        {
            uuid: '6167f23c2479f12101d557d7',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23c2479f12101d557d7',
            displayName: 'Fundamental Challenge for Ruby',
            language: 'Ruby',
            level: 'Basic',
            maxScore: 10000,
            taken: false,
        },
        {
            uuid: '6167f23e8df887fa6176a60d',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23e8df887fa6176a60d',
            displayName: 'Advanced Challenge for Java',
            language: 'Java',
            level: 'Advanced',
            maxScore: 20000,
            taken: false,
        },
        {
            uuid: '6167f23e2479f15231d557dd',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23e2479f15231d557dd',
            displayName: 'Advanced Challenge for Javascript',
            language: 'Javascript',
            level: 'Advanced',
            maxScore: 20000,
            taken: false,
        },
        {
            uuid: '6167f23a2479f14e4cd557d1',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23a2479f14e4cd557d1',
            displayName: 'Advanced Challenge for Python',
            language: 'Python',
            level: 'Advanced',
            maxScore: 20000,
            taken: true,
            highestScore: 18956,
        },
        {
            uuid: '6167f23f2479f1ecb9d557e0',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f23f2479f1ecb9d557e0',
            displayName: 'Advanced Challenge for .Net',
            language: '.Net',
            level: 'Advanced',
            maxScore: 20000,
            taken: true,
            highestScore: 12565,
        },
        {
            uuid: '6167f240c27d3d5d85952a07',
            url: 'codebashing-game-of-hacks/index.html?content_game_uuid=6167f240c27d3d5d85952a07',
            displayName: 'Advanced Challenge for C/C++',
            language: 'C/C++',
            level: 'Advanced',
            maxScore: 20000,
            taken: false,
        },
    ],
};
exports.mockChallengeUsersLeaderboard = {
    usersLeaderboard: {
        topTen: [
            {
                uuid: '21378e3dwbeid2',
                nicknameOrEmail: 'user-1',
                rank: 1,
                teams: '',
                points: 42983211,
                profilePicture: 'https://picsum.photos/200',
            },
            {
                uuid: '21378e3dwbeid1',
                nicknameOrEmail: 'current-user',
                rank: 2,
                teams: 'team3',
                points: 429832,
                profilePicture: 'https://picsum.photos/201',
            },
            {
                uuid: '21378e3dwbeid3',
                nicknameOrEmail: 'user-3',
                rank: 3,
                teams: '',
                points: 42983,
                profilePicture: 'https://picsum.photos/202',
            },
            {
                uuid: '21378e3dwbeid4',
                nicknameOrEmail: 'user-4',
                rank: 4,
                teams: 'team1',
                points: 429832,
                profilePicture: 'https://picsum.photos/203',
            },
            {
                uuid: '21378e3dwbeid5',
                nicknameOrEmail: 'user-5',
                rank: 5,
                teams: 'team1',
                points: 42983,
                profilePicture: 'https://picsum.photos/204',
            },
            {
                uuid: '21378e3dwbeid6',
                nicknameOrEmail: 'user-6',
                rank: 6,
                teams: 'team1',
                points: 42981,
                profilePicture: 'https://picsum.photos/205',
            },
            {
                uuid: '21378e3dwbeid7',
                nicknameOrEmail: 'user-7',
                rank: 7,
                teams: 'team1',
                points: 4297,
                profilePicture: 'https://picsum.photos/206',
            },
            {
                uuid: '21378e3dwbeid8',
                nicknameOrEmail: 'user-8',
                rank: 8,
                teams: 'team1, team2, team3, team4, team5, team6, team7, team8, team9, team10, team11',
                points: 4296,
                profilePicture: 'https://picsum.photos/207',
            },
            {
                uuid: '21378e3dwbeid9',
                nicknameOrEmail: 'user-9',
                rank: 9,
                teams: 'team1, team5',
                points: 429,
                profilePicture: 'https://picsum.photos/208',
            },
            {
                uuid: '21378e3dwbeid10',
                nicknameOrEmail: 'user-10',
                rank: 10,
                teams: 'team1',
                points: 10,
                profilePicture: 'https://picsum.photos/209',
            },
        ],
        currentUser: {
            uuid: '21378e3dwbeid1',
            nicknameOrEmail: 'current-user',
            rank: 2,
            teams: 'team1, team2, team3',
            points: 429832,
            profilePicture: 'https://picsum.photos/201',
        },
    },
};
exports.mockChallengeTeamsLeaderboard = {
    teamsLeaderboard: {
        myTeams: [
            {
                uuid: '21378e3dwbeid2',
                name: 'team-1',
                rank: 1,
                points: 42983211,
                membersCount: 22,
                usersCount: 12,
            },
            {
                uuid: '21378e3dwbeid1',
                name: 'team-2',
                rank: 2,
                points: 429832,
                membersCount: 12,
                usersCount: 12,
            },
            {
                uuid: '21378e3dwbeid3',
                name: 'team-3',
                rank: 3,
                points: 42983,
                membersCount: 6,
                usersCount: 3,
            },
            {
                uuid: '21378e3dwbeid4',
                name: 'team-4',
                rank: 4,
                points: 429832,
                membersCount: 9,
                usersCount: 9,
            },
        ],
        allTeams: [
            {
                uuid: '21378e3dwbeid2',
                name: 'team-1',
                rank: 1,
                points: 42983211,
                membersCount: 22,
                usersCount: 12,
            },
            {
                uuid: '21378e3dwbeid1',
                name: 'team-2',
                rank: 2,
                points: 429832,
                membersCount: 12,
                usersCount: 12,
            },
            {
                uuid: '21378e3dwbeid3',
                name: 'team-3',
                rank: 3,
                points: 42983,
                membersCount: 6,
                usersCount: 4,
            },
            {
                uuid: '21378e3dwbeid4',
                name: 'team-4',
                rank: 4,
                points: 429832,
                membersCount: 9,
                usersCount: 8,
            },
            {
                uuid: '21378e3dwbeid5',
                name: 'team-5',
                rank: 5,
                points: 42983,
                membersCount: 50,
                usersCount: 36,
            },
            {
                uuid: '21378e3dwbeid6',
                name: 'team-6',
                rank: 6,
                points: 42981,
                membersCount: 6,
                usersCount: 6,
            },
            {
                uuid: '21378e3dwbeid7',
                name: 'team-7',
                rank: 7,
                points: 4297,
                membersCount: 2,
                usersCount: 1,
            },
            {
                uuid: '21378e3dwbeid8',
                name: 'team-8',
                rank: 8,
                points: 4296,
                membersCount: 5,
                usersCount: 1,
            },
            {
                uuid: '21378e3dwbeid9',
                name: 'team-9',
                rank: 9,
                points: 429,
                membersCount: 3,
                usersCount: 3,
            },
            {
                uuid: '21378e3dwbeid10',
                name: 'team-10',
                rank: 10,
                points: 10,
                membersCount: 43,
                usersCount: 22,
            },
        ],
    },
};
